import React, { useState } from "react";
import "./Sticky_component.css";
import { User, ShoppingCart,Search,} from 'lucide-react';
import { useNavigate } from "react-router-dom";

function StickyComponent() {
  const navigate = useNavigate();
  const [toSearch, setToSearch] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  return (
    <div className="sticky-component-container">
      {
        showSearch && <div className="sticky-component-search">
          <input
            type="text"
            placeholder="Search"
            onChange={(e) => setToSearch(e.target.value)}
          />
          <Search onClick={() => navigate(`/search/${toSearch}`)} color="red" className="search-icon" />
        </div>
      }

      <div className="sticky-component">
        <div onClick={() => navigate("/my-account")}>
          <User />
          <h5>Account</h5>
        </div>
        <div onClick={() => navigate("/cart")}>
          <ShoppingCart />
          <h5>Cart</h5>
        </div>
        <div onClick={() => setShowSearch(!showSearch)}>
          <Search />
          <h5>Search</h5>
        </div>
      </div>

    </div>
  );
}

export default StickyComponent;